import { render } from "./Front.vue?vue&type=template&id=c499d5de&scoped=true"
import script from "./Front.vue?vue&type=script&lang=js"
export * from "./Front.vue?vue&type=script&lang=js"

import "./Front.vue?vue&type=style&index=0&id=c499d5de&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c499d5de"]])

export default __exports__